import * as form from '../form';

export const substanceThcPurchase = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        FirstInvolvement: form.datecontrol(xitem.FirstInvolvement),
        RecentInvolvement: form.datecontrol(xitem.RecentInvolvement),
        HowManyTimes: form.text(xitem.HowManyTimes),
        NatureOfInvolvement: form.textarea(xitem.NatureOfInvolvement),
        InvolvementWhileEmployed: form.branch(xitem.InvolvementWhileEmployed),
        InvolvementWhileEmployedPosition: form.text(xitem.InvolvementWhileEmployedPosition),
        InvolvementWhileEmployedExplanation: form.textarea(xitem.InvolvementWhileEmployedExplanation),
        InvolvementWithClearance: form.branch(xitem.InvolvementWithClearance),
        InvolvementWithClearanceExplanation: form.textarea(xitem.InvolvementWithClearanceExplanation),
        InvolvementInFuture: form.branch(xitem.InvolvementInFuture),
        InvolvementInFutureExplanation: form.textarea(xitem.InvolvementInFutureExplanation),
        InvolvementInFutureGovernment: form.branch(xitem.InvolvementInFutureGovernment),
        InvolvementInFutureGovernmentExplanation: form.textarea(xitem.InvolvementInFutureGovernmentExplanation),
        Reasons: form.textarea(xitem.Reasons),
      },
    };
  });
  return {
    Involved: form.branch(data.Involved),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
